<h2 mat-dialog-title class="dialog-title">
  <mat-icon>style</mat-icon>
  <span>Contract Cards</span>
  <button mat-icon-button (click)="load()">
    <mat-icon>refresh</mat-icon>
  </button>

  <span class="spacer"></span>
  <button mat-icon-button (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content>
  @if (loading) {
  <div class="loading-container">
    <mat-spinner diameter="36"></mat-spinner>
    <p>Loading cards...</p>
  </div>
  } @else {
  <div class="summary">
    Total: <strong>{{ cards.length }}</strong> cards &nbsp;·&nbsp;
    Listed: <strong>{{ countByStatus('Listed') }}</strong> &nbsp;·&nbsp;
    Sold: <strong>{{ countByStatus('Sold') }}</strong> &nbsp;·&nbsp;
    Expired: <strong>{{ countByStatus('Expired') }}</strong> &nbsp;·&nbsp;
    Quick Sold: <strong>{{ countByStatus('QuickSold') }}</strong> &nbsp;·&nbsp;
    Left Behind: <strong>{{ countByStatus('LeftBehind') }}</strong>
  </div>

  <div class="players-list">
    @for (group of cardGroups; track group.key) {
    <mat-accordion class="player-accordion">
      <mat-expansion-panel class="player-card" [class]="group.items[0].status.toLowerCase()">
        <mat-expansion-panel-header>
          <div class="player-header-expandable">
            @if (group.items[0].player_image_path) {
            <div class="player-thumb-wrapper" #thumbOrigin
              (click)="showImagePreview(thumbOrigin, group.items[0].player_image_path); $event.stopPropagation()">
              <img class="player-thumb" [src]="group.items[0].player_image_path" [alt]="group.items[0].player_name" />
            </div>
            }
            <div class="player-info">
              <div class="player-title">
                <span class="player-name">
                  {{ group.items[0].player_name }}
                  @if (group.items[0].player_nickname && group.items[0].player_nickname !== group.items[0].player_name)
                  {
                  ({{ group.items[0].player_nickname }})
                  }
                </span>
              </div>
              <div class="player-meta">
                <span class="count-badge">×{{ group.count }}</span>
                <span class="status">{{ group.items[0].status }}</span>
              </div>
            </div>

            <div class="price-info">
              <div class="price-row">
                <span class="price-label">Start Bid:</span>
                <span class="price-value">{{ group.items[0].bid_price | number }}</span>
              </div>
              <div class="price-row">
                <span class="price-label">Buy Now:</span>
                <span class="price-value">{{ group.items[0].buy_now_price| number }}</span>
              </div>
            </div>

          </div>
        </mat-expansion-panel-header>

        <div class="expansion-content">
          <div class="table-container">
            <table mat-table [dataSource]="group.items" class="mat-elevation-z4">
              <ng-container matColumnDef="player">
                <th mat-header-cell *matHeaderCellDef>Player</th>
                <td mat-cell *matCellDef="let c">
                  <div class="player-cell">
                    <span class="player-name">{{ c.player_name }}</span>
                    @if (c.player_nickname && c.player_nickname !== c.player_name) {
                    <span class="player-nick">({{ c.player_nickname }})</span>
                    }
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="buy_now_price">
                <th mat-header-cell *matHeaderCellDef>Buy Now</th>
                <td mat-cell *matCellDef="let c">{{ formatCoins(c.buy_now_price) }}</td>
              </ng-container>

              <ng-container matColumnDef="cost">
                <th mat-header-cell *matHeaderCellDef>Cost</th>
                <td mat-cell *matCellDef="let c">{{ formatCoins(c.cost) }}</td>
              </ng-container>

              <ng-container matColumnDef="quality">
                <th mat-header-cell *matHeaderCellDef>Quality</th>
                <td mat-cell *matCellDef="let c">{{ c.quality }}</td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let c">
                  <span [class]="'status-badge ' + getCardStatusClass(c.status)">{{ c.status }}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="expire_time">
                <th mat-header-cell *matHeaderCellDef>Expires in</th>
                <td mat-cell *matCellDef="let c">{{ formatTimeRemaining(c.expire_time) }}</td>
              </ng-container>

              @if (canShowHistory) {
              <ng-container matColumnDef="history">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let c">
                  <button mat-icon-button matTooltip="Show card history" (click)="showCardHistory(c.id)">
                    <mat-icon>history</mat-icon>
                  </button>
                </td>
              </ng-container>
              }

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            @if (cards.length === 0) {
            <div class="empty-state">No cards found for this contract.</div>
            }
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    }
  </div>
  }
</mat-dialog-content>

<ng-template #imagePreviewTpl>
  <div (click)="hideImagePreview()">
    <img class="player-thumb-overlay" [src]="previewImageUrl" alt="Player preview" />
  </div>
</ng-template>